import { PaletteOptions } from '@mui/material/styles';

/**
 * AI DTR Color Palette
 *
 * Light and dark palettes for the application theme.
 * Brand colors (navbar, buttons, accents) are also controlled via CSS variables
 * in src/styles/overrides.css — look for --brand-primary and [data-theme="dark"].
 */

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#0972d3', // AWS blue
    light: '#539fe5',
    dark: '#033160',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#414d5c', // AWS slate
    light: '#7d8998',
    dark: '#232f3e',
    contrastText: '#ffffff',
  },
  error: {
    main: '#d91515',
    light: '#eb5757',
    dark: '#8b0000',
  },
  warning: {
    main: '#ec7211', // AWS orange
    light: '#f89c4a',
    dark: '#c25400',
  },
  info: {
    main: '#0972d3',
    light: '#539fe5',
    dark: '#033160',
  },
  success: {
    main: '#037f0c',
    light: '#2ea043',
    dark: '#015c07',
  },
  background: {
    default: '#e1e4e8',
    paper: '#ffffff',
  },
  text: {
    primary: '#232f3e',
    secondary: '#687078',
    disabled: '#8d99a4',
  },
  divider: '#e9ebed',
  action: {
    active: '#0972d3',
    hover: 'rgba(9, 114, 211, 0.08)',
    selected: 'rgba(9, 114, 211, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#539fe5',
    light: '#7bb8ed',
    dark: '#0972d3',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#9ba7b6',
    light: '#b0bac5',
    dark: '#5a6b7a',
    contrastText: '#ffffff',
  },
  error: {
    main: '#eb5757',
    light: '#f28b8b',
    dark: '#d91515',
  },
  warning: {
    main: '#f89c4a',
    light: '#fbc07a',
    dark: '#ec7211',
  },
  info: {
    main: '#539fe5',
    light: '#7bb8ed',
    dark: '#0972d3',
  },
  success: {
    main: '#2ea043',
    light: '#56c06a',
    dark: '#037f0c',
  },
  background: {
    default: '#0f1b2d',
    paper: '#192231',
  },
  text: {
    primary: '#ffffff',
    secondary: '#d1d5db',
    disabled: '#6b7280',
  },
  divider: '#2a3a4a',
  action: {
    active: '#539fe5',
    hover: 'rgba(83, 159, 229, 0.15)',
    selected: 'rgba(83, 159, 229, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};

/** @deprecated Use `lightPalette` instead. Kept for backward compatibility. */
export const palette = lightPalette;
